import usePageTitle from '../hooks/usePageTitle';
import termsHtml from '../../private/terms.html';

const Terms = () => {
  usePageTitle('Terms and Conditions');

  return (
    <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
  );
};

export default Terms;
